import {Pipe, PipeTransform} from '@angular/core';
import {AuthService} from '../../core/services/auth.service';
import {NumberSeparatorEnum} from '../enums/number-separator.enum';

@Pipe({
  name: 'thousandSuffixes'
})
export class ThousandSuffixesPipe implements PipeTransform {

  constructor(private authService: AuthService) {
  }

  transform(input: any, fraction?: number): any {
    const suffixes = ['K', 'M', 'G', 'T', 'P', 'E'];

    if (Number.isNaN(input)) {
      return null;
    }

    if (input < 1000) {
      return input;
    }

    if (!fraction && fraction !== 0) {
      fraction = 1;
    }

    const exp = Math.floor(Math.log(input) / Math.log(1000));

    let resultNumber = parseFloat((input / Math.pow(1000, exp)).toFixed(fraction)).toString(10);
    if (this.authService.user && this.authService.user.Decimal_Separator === NumberSeparatorEnum.COMMA) {
      resultNumber = resultNumber.replace('.', ',');
    }

    return resultNumber + suffixes[exp - 1];
  }

}
